"use strict";
/**
* Do not edit directly
* Generated on Wed, 26 Mar 2025 17:40:45 GMT
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenName = void 0;
var TokenName;
(function (TokenName) {
    TokenName["backgroundStaticFlat"] = "backgroundStaticFlat";
    TokenName["backgroundStaticRaised"] = "backgroundStaticRaised";
    TokenName["backgroundStaticFloating"] = "backgroundStaticFloating";
    TokenName["backgroundStaticSunken"] = "backgroundStaticSunken";
    TokenName["backgroundStaticInverse"] = "backgroundStaticInverse";
    TokenName["backgroundStaticOnColor"] = "backgroundStaticOnColor";
    TokenName["backgroundStaticInverseOnColor"] = "backgroundStaticInverseOnColor";
    TokenName["backgroundInteractivePrimaryDefault"] = "backgroundInteractivePrimaryDefault";
    TokenName["backgroundInteractivePrimaryHover"] = "backgroundInteractivePrimaryHover";
    TokenName["backgroundInteractivePrimaryActive"] = "backgroundInteractivePrimaryActive";
    TokenName["backgroundInteractiveSecondaryDefault"] = "backgroundInteractiveSecondaryDefault";
    TokenName["backgroundInteractiveSecondaryHover"] = "backgroundInteractiveSecondaryHover";
    TokenName["backgroundInteractiveSecondaryActive"] = "backgroundInteractiveSecondaryActive";
    TokenName["backgroundInteractiveDangerDefault"] = "backgroundInteractiveDangerDefault";
    TokenName["backgroundInteractiveDangerHover"] = "backgroundInteractiveDangerHover";
    TokenName["backgroundInteractiveDangerActive"] = "backgroundInteractiveDangerActive";
    TokenName["backgroundInteractiveNeutralSubtleDefault"] = "backgroundInteractiveNeutralSubtleDefault";
    TokenName["backgroundInteractiveNeutralSubtleHover"] = "backgroundInteractiveNeutralSubtleHover";
    TokenName["backgroundInteractiveNeutralSubtleActive"] = "backgroundInteractiveNeutralSubtleActive";
    TokenName["backgroundInteractiveNeutralDefault"] = "backgroundInteractiveNeutralDefault";
    TokenName["backgroundInteractiveNeutralHover"] = "backgroundInteractiveNeutralHover";
    TokenName["backgroundInteractiveNeutralActive"] = "backgroundInteractiveNeutralActive";
    TokenName["backgroundInteractiveNeutralBoldDefault"] = "backgroundInteractiveNeutralBoldDefault";
    TokenName["backgroundInteractiveNeutralBoldHover"] = "backgroundInteractiveNeutralBoldHover";
    TokenName["backgroundInteractiveNeutralBoldActive"] = "backgroundInteractiveNeutralBoldActive";
    TokenName["backgroundInteractiveSuccessDefault"] = "backgroundInteractiveSuccessDefault";
    TokenName["backgroundInteractiveSuccessHover"] = "backgroundInteractiveSuccessHover";
    TokenName["backgroundInteractiveSuccessActive"] = "backgroundInteractiveSuccessActive";
    TokenName["backgroundAlertWarningPrimary"] = "backgroundAlertWarningPrimary";
    TokenName["backgroundAlertWarningSecondary"] = "backgroundAlertWarningSecondary";
    TokenName["backgroundAlertSuccessPrimary"] = "backgroundAlertSuccessPrimary";
    TokenName["backgroundAlertSuccessSecondary"] = "backgroundAlertSuccessSecondary";
    TokenName["backgroundAlertInfoPrimary"] = "backgroundAlertInfoPrimary";
    TokenName["backgroundAlertInfoSecondary"] = "backgroundAlertInfoSecondary";
    TokenName["backgroundAlertDangerPrimary"] = "backgroundAlertDangerPrimary";
    TokenName["backgroundAlertDangerSecondary"] = "backgroundAlertDangerSecondary";
    TokenName["backgroundAlertBasicPrimary"] = "backgroundAlertBasicPrimary";
    TokenName["backgroundAlertBasicSecondary"] = "backgroundAlertBasicSecondary";
    TokenName["backgroundAccentPrimary"] = "backgroundAccentPrimary";
    TokenName["backgroundAccentSecondary"] = "backgroundAccentSecondary";
    TokenName["backgroundAccentBrand"] = "backgroundAccentBrand";
    TokenName["backgroundAccentInfo"] = "backgroundAccentInfo";
    TokenName["backgroundAccentDanger"] = "backgroundAccentDanger";
    TokenName["backgroundAccentSuccess"] = "backgroundAccentSuccess";
    TokenName["backgroundAccentWarning"] = "backgroundAccentWarning";
    TokenName["backgroundAccentGradient"] = "backgroundAccentGradient";
    TokenName["backgroundDisabled"] = "backgroundDisabled";
    TokenName["backgroundBrand"] = "backgroundBrand";
    TokenName["backgroundBackdrop"] = "backgroundBackdrop";
    TokenName["backgroundDatavizBlue"] = "backgroundDatavizBlue";
    TokenName["backgroundDatavizOrange"] = "backgroundDatavizOrange";
    TokenName["backgroundDatavizGreen"] = "backgroundDatavizGreen";
    TokenName["backgroundDatavizRed"] = "backgroundDatavizRed";
    TokenName["backgroundDatavizPurple"] = "backgroundDatavizPurple";
    TokenName["backgroundDatavizPink"] = "backgroundDatavizPink";
    TokenName["textStaticPrimary"] = "textStaticPrimary";
    TokenName["textStaticSecondary"] = "textStaticSecondary";
    TokenName["textStaticTertiary"] = "textStaticTertiary";
    TokenName["textStaticInverse"] = "textStaticInverse";
    TokenName["textStaticOnColor"] = "textStaticOnColor";
    TokenName["textInteractivePrimaryDefault"] = "textInteractivePrimaryDefault";
    TokenName["textInteractivePrimaryHover"] = "textInteractivePrimaryHover";
    TokenName["textInteractivePrimaryActive"] = "textInteractivePrimaryActive";
    TokenName["textInteractiveSecondaryDefault"] = "textInteractiveSecondaryDefault";
    TokenName["textInteractiveSecondaryHover"] = "textInteractiveSecondaryHover";
    TokenName["textInteractiveSecondaryActive"] = "textInteractiveSecondaryActive";
    TokenName["textAlertDanger"] = "textAlertDanger";
    TokenName["textAlertWarning"] = "textAlertWarning";
    TokenName["textAlertSuccess"] = "textAlertSuccess";
    TokenName["textAlertInfo"] = "textAlertInfo";
    TokenName["textAlertBasic"] = "textAlertBasic";
    TokenName["textDisabled"] = "textDisabled";
    TokenName["borderStaticPrimary"] = "borderStaticPrimary";
    TokenName["borderStaticSecondary"] = "borderStaticSecondary";
    TokenName["borderStaticInverse"] = "borderStaticInverse";
    TokenName["borderStaticOnColor"] = "borderStaticOnColor";
    TokenName["borderStaticTertiary"] = "borderStaticTertiary";
    TokenName["borderAlertBasic"] = "borderAlertBasic";
    TokenName["borderAlertSuccess"] = "borderAlertSuccess";
    TokenName["borderAlertInfo"] = "borderAlertInfo";
    TokenName["borderAlertDanger"] = "borderAlertDanger";
    TokenName["borderAlertWarning"] = "borderAlertWarning";
    TokenName["borderInteractivePrimaryDefault"] = "borderInteractivePrimaryDefault";
    TokenName["borderInteractivePrimaryHover"] = "borderInteractivePrimaryHover";
    TokenName["borderInteractivePrimaryActive"] = "borderInteractivePrimaryActive";
    TokenName["borderInteractiveSecondaryDefault"] = "borderInteractiveSecondaryDefault";
    TokenName["borderInteractiveSecondaryHover"] = "borderInteractiveSecondaryHover";
    TokenName["borderInteractiveSecondaryActive"] = "borderInteractiveSecondaryActive";
    TokenName["borderInteractiveBoldDefault"] = "borderInteractiveBoldDefault";
    TokenName["borderInteractiveBoldHover"] = "borderInteractiveBoldHover";
    TokenName["borderInteractiveBoldActive"] = "borderInteractiveBoldActive";
    TokenName["borderInteractiveFocus"] = "borderInteractiveFocus";
    TokenName["borderDisabled"] = "borderDisabled";
    TokenName["borderAccent"] = "borderAccent";
    TokenName["borderBrand"] = "borderBrand";
    TokenName["legacyTagBackgroundBasicBold"] = "legacyTagBackgroundBasicBold";
    TokenName["legacyTagBackgroundPrimary"] = "legacyTagBackgroundPrimary";
    TokenName["legacyTagBackgroundDenim"] = "legacyTagBackgroundDenim";
    TokenName["legacyTagBackgroundLime"] = "legacyTagBackgroundLime";
    TokenName["legacyTagBackgroundMustard"] = "legacyTagBackgroundMustard";
    TokenName["legacyTagBackgroundLavender"] = "legacyTagBackgroundLavender";
    TokenName["legacyTagBackgroundRuby"] = "legacyTagBackgroundRuby";
    TokenName["legacyTagBackgroundTangerine"] = "legacyTagBackgroundTangerine";
    TokenName["legacyTagBorderBasicBold"] = "legacyTagBorderBasicBold";
    TokenName["legacyTagBorderPrimary"] = "legacyTagBorderPrimary";
    TokenName["legacyTagBorderDenim"] = "legacyTagBorderDenim";
    TokenName["legacyTagBorderLime"] = "legacyTagBorderLime";
    TokenName["legacyTagBorderMustard"] = "legacyTagBorderMustard";
    TokenName["legacyTagBorderLavender"] = "legacyTagBorderLavender";
    TokenName["legacyTagBorderRuby"] = "legacyTagBorderRuby";
    TokenName["legacyTagBorderTangerine"] = "legacyTagBorderTangerine";
    TokenName["legacyTagTextBasicBold"] = "legacyTagTextBasicBold";
    TokenName["legacyTagTextPrimary"] = "legacyTagTextPrimary";
    TokenName["legacyTagTextDenim"] = "legacyTagTextDenim";
    TokenName["legacyTagTextLime"] = "legacyTagTextLime";
    TokenName["legacyTagTextMustard"] = "legacyTagTextMustard";
    TokenName["legacyTagTextLavender"] = "legacyTagTextLavender";
    TokenName["legacyTagTextRuby"] = "legacyTagTextRuby";
    TokenName["legacyTagTextTangerine"] = "legacyTagTextTangerine";
    TokenName["legacyDatavizDenim50"] = "legacyDatavizDenim50";
    TokenName["legacyDatavizDenim100"] = "legacyDatavizDenim100";
    TokenName["legacyDatavizDenim200"] = "legacyDatavizDenim200";
    TokenName["legacyDatavizDenim300"] = "legacyDatavizDenim300";
    TokenName["legacyDatavizDenim400"] = "legacyDatavizDenim400";
    TokenName["legacyDatavizDenim500"] = "legacyDatavizDenim500";
    TokenName["legacyDatavizDenim600"] = "legacyDatavizDenim600";
    TokenName["legacyDatavizDenim700"] = "legacyDatavizDenim700";
    TokenName["legacyDatavizDenim800"] = "legacyDatavizDenim800";
    TokenName["legacyDatavizDenim900"] = "legacyDatavizDenim900";
    TokenName["legacyDatavizLavender50"] = "legacyDatavizLavender50";
    TokenName["legacyDatavizLavender100"] = "legacyDatavizLavender100";
    TokenName["legacyDatavizLavender200"] = "legacyDatavizLavender200";
    TokenName["legacyDatavizLavender300"] = "legacyDatavizLavender300";
    TokenName["legacyDatavizLavender400"] = "legacyDatavizLavender400";
    TokenName["legacyDatavizLavender500"] = "legacyDatavizLavender500";
    TokenName["legacyDatavizLavender600"] = "legacyDatavizLavender600";
    TokenName["legacyDatavizLavender700"] = "legacyDatavizLavender700";
    TokenName["legacyDatavizLavender800"] = "legacyDatavizLavender800";
    TokenName["legacyDatavizLavender900"] = "legacyDatavizLavender900";
    TokenName["legacyDatavizLime50"] = "legacyDatavizLime50";
    TokenName["legacyDatavizLime100"] = "legacyDatavizLime100";
    TokenName["legacyDatavizLime200"] = "legacyDatavizLime200";
    TokenName["legacyDatavizLime300"] = "legacyDatavizLime300";
    TokenName["legacyDatavizLime400"] = "legacyDatavizLime400";
    TokenName["legacyDatavizLime500"] = "legacyDatavizLime500";
    TokenName["legacyDatavizLime600"] = "legacyDatavizLime600";
    TokenName["legacyDatavizLime700"] = "legacyDatavizLime700";
    TokenName["legacyDatavizLime800"] = "legacyDatavizLime800";
    TokenName["legacyDatavizLime900"] = "legacyDatavizLime900";
    TokenName["legacyDatavizMustard50"] = "legacyDatavizMustard50";
    TokenName["legacyDatavizMustard100"] = "legacyDatavizMustard100";
    TokenName["legacyDatavizMustard200"] = "legacyDatavizMustard200";
    TokenName["legacyDatavizMustard300"] = "legacyDatavizMustard300";
    TokenName["legacyDatavizMustard400"] = "legacyDatavizMustard400";
    TokenName["legacyDatavizMustard500"] = "legacyDatavizMustard500";
    TokenName["legacyDatavizMustard600"] = "legacyDatavizMustard600";
    TokenName["legacyDatavizMustard700"] = "legacyDatavizMustard700";
    TokenName["legacyDatavizMustard800"] = "legacyDatavizMustard800";
    TokenName["legacyDatavizMustard900"] = "legacyDatavizMustard900";
    TokenName["legacyDatavizTangerine50"] = "legacyDatavizTangerine50";
    TokenName["legacyDatavizTangerine100"] = "legacyDatavizTangerine100";
    TokenName["legacyDatavizTangerine200"] = "legacyDatavizTangerine200";
    TokenName["legacyDatavizTangerine300"] = "legacyDatavizTangerine300";
    TokenName["legacyDatavizTangerine400"] = "legacyDatavizTangerine400";
    TokenName["legacyDatavizTangerine500"] = "legacyDatavizTangerine500";
    TokenName["legacyDatavizTangerine600"] = "legacyDatavizTangerine600";
    TokenName["legacyDatavizTangerine700"] = "legacyDatavizTangerine700";
    TokenName["legacyDatavizTangerine800"] = "legacyDatavizTangerine800";
    TokenName["legacyDatavizTangerine900"] = "legacyDatavizTangerine900";
    TokenName["legacyDatavizRuby50"] = "legacyDatavizRuby50";
    TokenName["legacyDatavizRuby100"] = "legacyDatavizRuby100";
    TokenName["legacyDatavizRuby200"] = "legacyDatavizRuby200";
    TokenName["legacyDatavizRuby300"] = "legacyDatavizRuby300";
    TokenName["legacyDatavizRuby400"] = "legacyDatavizRuby400";
    TokenName["legacyDatavizRuby500"] = "legacyDatavizRuby500";
    TokenName["legacyDatavizRuby600"] = "legacyDatavizRuby600";
    TokenName["legacyDatavizRuby700"] = "legacyDatavizRuby700";
    TokenName["legacyDatavizRuby800"] = "legacyDatavizRuby800";
    TokenName["legacyDatavizRuby900"] = "legacyDatavizRuby900";
    TokenName["paletteBrandIndigo25"] = "paletteBrandIndigo25";
    TokenName["paletteBrandIndigo50"] = "paletteBrandIndigo50";
    TokenName["paletteBrandIndigo100"] = "paletteBrandIndigo100";
    TokenName["paletteBrandIndigo150"] = "paletteBrandIndigo150";
    TokenName["paletteBrandIndigo200"] = "paletteBrandIndigo200";
    TokenName["paletteBrandIndigo300"] = "paletteBrandIndigo300";
    TokenName["paletteBrandIndigo400"] = "paletteBrandIndigo400";
    TokenName["paletteBrandIndigo500"] = "paletteBrandIndigo500";
    TokenName["paletteBrandIndigo600"] = "paletteBrandIndigo600";
    TokenName["paletteBrandIndigo700"] = "paletteBrandIndigo700";
    TokenName["paletteBrandIndigo800"] = "paletteBrandIndigo800";
    TokenName["paletteBrandIndigo900"] = "paletteBrandIndigo900";
    TokenName["paletteBrandIndigo1000"] = "paletteBrandIndigo1000";
    TokenName["paletteBrandNight0"] = "paletteBrandNight0";
    TokenName["paletteBrandNight25"] = "paletteBrandNight25";
    TokenName["paletteBrandNight50"] = "paletteBrandNight50";
    TokenName["paletteBrandNight100"] = "paletteBrandNight100";
    TokenName["paletteBrandNight150"] = "paletteBrandNight150";
    TokenName["paletteBrandNight200"] = "paletteBrandNight200";
    TokenName["paletteBrandNight300"] = "paletteBrandNight300";
    TokenName["paletteBrandNight400"] = "paletteBrandNight400";
    TokenName["paletteBrandNight500"] = "paletteBrandNight500";
    TokenName["paletteBrandNight600"] = "paletteBrandNight600";
    TokenName["paletteBrandNight700"] = "paletteBrandNight700";
    TokenName["paletteBrandNight800"] = "paletteBrandNight800";
    TokenName["paletteBrandNight900"] = "paletteBrandNight900";
    TokenName["paletteBrandNight1000"] = "paletteBrandNight1000";
    TokenName["paletteBrandNight10008"] = "paletteBrandNight10008";
    TokenName["paletteBrandNight100012"] = "paletteBrandNight100012";
    TokenName["paletteBrandNight100016"] = "paletteBrandNight100016";
    TokenName["paletteBrandNight064"] = "paletteBrandNight064";
    TokenName["paletteBrandCoral25"] = "paletteBrandCoral25";
    TokenName["paletteBrandCoral50"] = "paletteBrandCoral50";
    TokenName["paletteBrandCoral100"] = "paletteBrandCoral100";
    TokenName["paletteBrandCoral150"] = "paletteBrandCoral150";
    TokenName["paletteBrandCoral200"] = "paletteBrandCoral200";
    TokenName["paletteBrandCoral300"] = "paletteBrandCoral300";
    TokenName["paletteBrandCoral400"] = "paletteBrandCoral400";
    TokenName["paletteBrandCoral500"] = "paletteBrandCoral500";
    TokenName["paletteBrandCoral600"] = "paletteBrandCoral600";
    TokenName["paletteBrandCoral700"] = "paletteBrandCoral700";
    TokenName["paletteBrandCoral800"] = "paletteBrandCoral800";
    TokenName["paletteBrandCoral900"] = "paletteBrandCoral900";
    TokenName["paletteBrandCoral1000"] = "paletteBrandCoral1000";
    TokenName["paletteBrandGrey0"] = "paletteBrandGrey0";
    TokenName["paletteBrandGrey25"] = "paletteBrandGrey25";
    TokenName["paletteBrandGrey50"] = "paletteBrandGrey50";
    TokenName["paletteBrandGrey100"] = "paletteBrandGrey100";
    TokenName["paletteBrandGrey150"] = "paletteBrandGrey150";
    TokenName["paletteBrandGrey200"] = "paletteBrandGrey200";
    TokenName["paletteBrandGrey300"] = "paletteBrandGrey300";
    TokenName["paletteBrandGrey400"] = "paletteBrandGrey400";
    TokenName["paletteBrandGrey500"] = "paletteBrandGrey500";
    TokenName["paletteBrandGrey600"] = "paletteBrandGrey600";
    TokenName["paletteBrandGrey700"] = "paletteBrandGrey700";
    TokenName["paletteBrandGrey800"] = "paletteBrandGrey800";
    TokenName["paletteBrandGrey900"] = "paletteBrandGrey900";
    TokenName["paletteBrandGrey1000"] = "paletteBrandGrey1000";
    TokenName["paletteSemanticBlue25"] = "paletteSemanticBlue25";
    TokenName["paletteSemanticBlue50"] = "paletteSemanticBlue50";
    TokenName["paletteSemanticBlue100"] = "paletteSemanticBlue100";
    TokenName["paletteSemanticBlue150"] = "paletteSemanticBlue150";
    TokenName["paletteSemanticBlue200"] = "paletteSemanticBlue200";
    TokenName["paletteSemanticBlue300"] = "paletteSemanticBlue300";
    TokenName["paletteSemanticBlue400"] = "paletteSemanticBlue400";
    TokenName["paletteSemanticBlue500"] = "paletteSemanticBlue500";
    TokenName["paletteSemanticBlue600"] = "paletteSemanticBlue600";
    TokenName["paletteSemanticBlue700"] = "paletteSemanticBlue700";
    TokenName["paletteSemanticBlue800"] = "paletteSemanticBlue800";
    TokenName["paletteSemanticBlue900"] = "paletteSemanticBlue900";
    TokenName["paletteSemanticBlue1000"] = "paletteSemanticBlue1000";
    TokenName["paletteSemanticOrange25"] = "paletteSemanticOrange25";
    TokenName["paletteSemanticOrange50"] = "paletteSemanticOrange50";
    TokenName["paletteSemanticOrange100"] = "paletteSemanticOrange100";
    TokenName["paletteSemanticOrange150"] = "paletteSemanticOrange150";
    TokenName["paletteSemanticOrange200"] = "paletteSemanticOrange200";
    TokenName["paletteSemanticOrange300"] = "paletteSemanticOrange300";
    TokenName["paletteSemanticOrange400"] = "paletteSemanticOrange400";
    TokenName["paletteSemanticOrange500"] = "paletteSemanticOrange500";
    TokenName["paletteSemanticOrange600"] = "paletteSemanticOrange600";
    TokenName["paletteSemanticOrange700"] = "paletteSemanticOrange700";
    TokenName["paletteSemanticOrange800"] = "paletteSemanticOrange800";
    TokenName["paletteSemanticOrange900"] = "paletteSemanticOrange900";
    TokenName["paletteSemanticOrange1000"] = "paletteSemanticOrange1000";
    TokenName["paletteSemanticGreen25"] = "paletteSemanticGreen25";
    TokenName["paletteSemanticGreen50"] = "paletteSemanticGreen50";
    TokenName["paletteSemanticGreen100"] = "paletteSemanticGreen100";
    TokenName["paletteSemanticGreen150"] = "paletteSemanticGreen150";
    TokenName["paletteSemanticGreen200"] = "paletteSemanticGreen200";
    TokenName["paletteSemanticGreen300"] = "paletteSemanticGreen300";
    TokenName["paletteSemanticGreen400"] = "paletteSemanticGreen400";
    TokenName["paletteSemanticGreen500"] = "paletteSemanticGreen500";
    TokenName["paletteSemanticGreen600"] = "paletteSemanticGreen600";
    TokenName["paletteSemanticGreen700"] = "paletteSemanticGreen700";
    TokenName["paletteSemanticGreen800"] = "paletteSemanticGreen800";
    TokenName["paletteSemanticGreen900"] = "paletteSemanticGreen900";
    TokenName["paletteSemanticGreen1000"] = "paletteSemanticGreen1000";
    TokenName["paletteSemanticRed25"] = "paletteSemanticRed25";
    TokenName["paletteSemanticRed50"] = "paletteSemanticRed50";
    TokenName["paletteSemanticRed100"] = "paletteSemanticRed100";
    TokenName["paletteSemanticRed150"] = "paletteSemanticRed150";
    TokenName["paletteSemanticRed200"] = "paletteSemanticRed200";
    TokenName["paletteSemanticRed300"] = "paletteSemanticRed300";
    TokenName["paletteSemanticRed400"] = "paletteSemanticRed400";
    TokenName["paletteSemanticRed500"] = "paletteSemanticRed500";
    TokenName["paletteSemanticRed600"] = "paletteSemanticRed600";
    TokenName["paletteSemanticRed700"] = "paletteSemanticRed700";
    TokenName["paletteSemanticRed800"] = "paletteSemanticRed800";
    TokenName["paletteSemanticRed900"] = "paletteSemanticRed900";
    TokenName["paletteSemanticRed1000"] = "paletteSemanticRed1000";
    TokenName["paletteDatavizBlue"] = "paletteDatavizBlue";
    TokenName["paletteDatavizOrange"] = "paletteDatavizOrange";
    TokenName["paletteDatavizGreen"] = "paletteDatavizGreen";
    TokenName["paletteDatavizRed"] = "paletteDatavizRed";
    TokenName["paletteDatavizPink"] = "paletteDatavizPink";
    TokenName["paletteDatavizPurple"] = "paletteDatavizPurple";
    TokenName["paletteBasicsBlack"] = "paletteBasicsBlack";
    TokenName["paletteBasicsWhite"] = "paletteBasicsWhite";
    TokenName["paletteBasicsWhite64"] = "paletteBasicsWhite64";
    TokenName["shadow0"] = "shadow0";
    TokenName["shadow100"] = "shadow100";
    TokenName["shadow200"] = "shadow200";
    TokenName["shadow300"] = "shadow300";
    TokenName["fontSizeRatio"] = "fontSizeRatio";
    TokenName["fontSize50"] = "fontSize50";
    TokenName["fontSize75"] = "fontSize75";
    TokenName["fontSize100"] = "fontSize100";
    TokenName["fontSize200"] = "fontSize200";
    TokenName["fontSize300"] = "fontSize300";
    TokenName["fontSize400"] = "fontSize400";
    TokenName["fontSize500"] = "fontSize500";
    TokenName["fontSize600"] = "fontSize600";
    TokenName["fontSize700"] = "fontSize700";
    TokenName["fontSize800"] = "fontSize800";
    TokenName["fontSize900"] = "fontSize900";
    TokenName["fontSizeBase"] = "fontSizeBase";
    TokenName["fontFamilyUi"] = "fontFamilyUi";
    TokenName["fontWeight300"] = "fontWeight300";
    TokenName["fontWeight400"] = "fontWeight400";
    TokenName["fontWeight500"] = "fontWeight500";
    TokenName["fontWeight600"] = "fontWeight600";
    TokenName["lineHeight100"] = "lineHeight100";
    TokenName["lineHeight200"] = "lineHeight200";
    TokenName["lineHeight300"] = "lineHeight300";
    TokenName["letterSpacingCondensed"] = "letterSpacingCondensed";
    TokenName["letterSpacingDefault"] = "letterSpacingDefault";
    TokenName["letterSpacingWide"] = "letterSpacingWide";
    TokenName["textDecorationUnderline"] = "textDecorationUnderline";
    TokenName["highlightLarge"] = "highlightLarge";
    TokenName["highlightMedium"] = "highlightMedium";
    TokenName["highlightSmall"] = "highlightSmall";
    TokenName["titleLarge"] = "titleLarge";
    TokenName["titleLargeStrong"] = "titleLargeStrong";
    TokenName["titleMedium"] = "titleMedium";
    TokenName["titleMediumStrong"] = "titleMediumStrong";
    TokenName["titleSmall"] = "titleSmall";
    TokenName["titleSmallStrong"] = "titleSmallStrong";
    TokenName["bodyLarge"] = "bodyLarge";
    TokenName["bodyLargeStrong"] = "bodyLargeStrong";
    TokenName["bodyMedium"] = "bodyMedium";
    TokenName["bodyMediumStrong"] = "bodyMediumStrong";
    TokenName["bodySmall"] = "bodySmall";
    TokenName["bodySmallStrong"] = "bodySmallStrong";
    TokenName["bodyExtraSmall"] = "bodyExtraSmall";
    TokenName["bodyExtraSmallStrong"] = "bodyExtraSmallStrong";
    TokenName["spacing0"] = "spacing0";
    TokenName["spacing25"] = "spacing25";
    TokenName["spacing50"] = "spacing50";
    TokenName["spacing100"] = "spacing100";
    TokenName["spacing150"] = "spacing150";
    TokenName["spacing200"] = "spacing200";
    TokenName["spacing250"] = "spacing250";
    TokenName["spacing300"] = "spacing300";
    TokenName["spacing400"] = "spacing400";
    TokenName["spacing450"] = "spacing450";
    TokenName["spacing500"] = "spacing500";
    TokenName["spacing600"] = "spacing600";
    TokenName["spacing700"] = "spacing700";
    TokenName["spacing800"] = "spacing800";
    TokenName["spacing900"] = "spacing900";
    TokenName["spacing1000"] = "spacing1000";
    TokenName["spacing1200"] = "spacing1200";
    TokenName["borderRadius0"] = "borderRadius0";
    TokenName["borderRadius25"] = "borderRadius25";
    TokenName["borderRadius50"] = "borderRadius50";
    TokenName["borderRadius100"] = "borderRadius100";
    TokenName["borderRadius150"] = "borderRadius150";
    TokenName["borderRadius200"] = "borderRadius200";
    TokenName["borderRadius300"] = "borderRadius300";
    TokenName["borderRadiusRound"] = "borderRadiusRound";
    TokenName["borderRadiusBase"] = "borderRadiusBase";
    TokenName["spacingBase"] = "spacingBase";
    TokenName["borderWidth0"] = "borderWidth0";
    TokenName["borderWidth100"] = "borderWidth100";
    TokenName["borderWidth150"] = "borderWidth150";
    TokenName["borderWidth200"] = "borderWidth200";
    TokenName["borderWidth250"] = "borderWidth250";
    TokenName["borderWidth300"] = "borderWidth300";
    TokenName["borderWidth800"] = "borderWidth800";
    TokenName["sizingBase"] = "sizingBase";
    TokenName["sizing50"] = "sizing50";
    TokenName["sizing100"] = "sizing100";
    TokenName["sizing200"] = "sizing200";
    TokenName["sizing300"] = "sizing300";
    TokenName["sizing400"] = "sizing400";
    TokenName["sizing500"] = "sizing500";
    TokenName["sizing550"] = "sizing550";
    TokenName["sizing600"] = "sizing600";
    TokenName["sizing700"] = "sizing700";
    TokenName["sizing800"] = "sizing800";
    TokenName["sizing900"] = "sizing900";
    TokenName["sizing1000"] = "sizing1000";
    TokenName["sizing1200"] = "sizing1200";
    TokenName["sizing1300"] = "sizing1300";
    TokenName["opacity0"] = "opacity0";
    TokenName["opacity100"] = "opacity100";
    TokenName["opacity150"] = "opacity150";
    TokenName["opacity200"] = "opacity200";
    TokenName["opacity400"] = "opacity400";
    TokenName["opacity600"] = "opacity600";
    TokenName["opacity800"] = "opacity800";
    TokenName["opacity1000"] = "opacity1000";
})(TokenName || (exports.TokenName = TokenName = {}));
